import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSettings } from '../util/getSettings';
import { QsStateManager } from '../util/urls';
import { quickMoveInUpdated, filtersUpdated } from '../redux/actions/filters';
import Toggle from './shared/toggle';

const QuickMoveIn = ({onChange, mobile}) => {
  const [quickMoveIn, setQuickMoveIn] = useState(false);
  const filters = useSelector((state) => state.filters);
  const labels = getSettings(['century', 'labels'], true);
  const dispatch = useDispatch();

  useEffect(() => {
    setQuickMoveIn(filters.quickMoveIn);
  }, [filters.timeStamp, filters.resetTimeStamp]);

  const toggleQuickMoveIn = (value) => {
    setQuickMoveIn(value);
    if(mobile) {
      onChange(value);
    } else {
      dispatch(quickMoveInUpdated(value));
      dispatch(filtersUpdated());
      new QsStateManager().addParam('qm', value, !value).addFilters(filters).doUpdate();
    }
  };

  return (
    <Toggle
      toggleTitle={labels.quickMoveInTextLabel}
      checked={quickMoveIn}
      onChange={toggleQuickMoveIn}
    />
  );
};

export default QuickMoveIn;
